module.exports = __webpack_public_path__ + "static/img/10.7711efa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/sp/10.png
// module id = g7vT
// module chunks = 0